export enum ActionType {
  SET_USER_ROLE,
}

export interface SET_USER_ROLE {
  type: ActionType.SET_USER_ROLE
  payload: {
    token?: string
  }
}

export type UserActions = SET_USER_ROLE
